import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { SignOutOnError } from '@platform-frontend/account';
import {
  AcademicState,
  CancelAcademicVerification,
  CheckAcademicVerification,
  CompleteAcademicVerification,
  MSG_ACADEMIC_VERIFICATION_COMPLETION_FAILED,
  ResendAcademicVerification
} from '@platform-frontend/checkout';
import { PollingConfiguration } from '@platform-frontend/platform';
import { Navigate, ShowSuccessNotification, handleAllErrors } from '@platform-frontend/util';
import { Observable } from 'rxjs';
import { map, retry, switchMap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'yat-verify-academic-email',
  templateUrl: './verify-academic-email.component.html',
  styleUrls: ['./verify-academic-email.component.scss']
})
export class VerifyAcademicEmailComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private store: Store) {}

  @Select(AcademicState.email)
  email$: Observable<string | null>;

  pollingConfiguration: PollingConfiguration;

  ngOnInit(): void {
    this.pollingConfiguration = {
      poll: (timeout: number) =>
        this.store.dispatch(new CheckAcademicVerification(timeout)).pipe(map(() => this.store.selectSnapshot(AcademicState.emailVerified))),
      complete: () =>
        this.store
          .dispatch(new CompleteAcademicVerification())
          .pipe(retry(2), handleAllErrors(new SignOutOnError(new ShowSuccessNotification(MSG_ACADEMIC_VERIFICATION_COMPLETION_FAILED)))),
      proceed: () => this.store.dispatch(new Navigate(['../confirmation'], { relativeTo: this.activatedRoute })),
      completeRetryCount: 1
    };
  }

  resendVerification(): void {
    this.store.dispatch(new ResendAcademicVerification());
  }

  cancelSignUp(): void {
    this.store
      .dispatch(new CancelAcademicVerification())
      .pipe(
        switchMap(() => this.store.dispatch(new Navigate(['../academic-registration'], { relativeTo: this.activatedRoute }))),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
